import React from 'react';
import properties from '../../constants/Properties';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import videoUtils from '../utils/VideoUtils';

const BrowserButtonContent = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight || this.props.activeButton != newProps.activeButton)
            return true;
        else
            return false;
    },
    render() {
        let topPosition;
        let listHeight = this.props.windowHeight - this.props.topButtonsOffset - this.props.length * properties.BROWSER_BUTTON_HEIGHT;
        var listOffset = 0;

        if (videoUtils.browserActiveButton != -1 && this.props.index > videoUtils.browserActiveButton)
            listOffset = listHeight;

        topPosition = this.props.topButtonsOffset + properties.BROWSER_BUTTON_HEIGHT * this.props.index + listOffset;

        var buttonColor;
        var textColor;
        var icon;
        var iconColor;

        if (this.props.index == this.props.activeButton) {
            buttonColor = properties.BROWSER_SELECTED_COLOR;
            textColor = '#F7F7F7';
            icon = 'fa fa-angle-down';
            iconColor = 'white';
        }
        else {
            icon = 'fa fa-angle-right';
            iconColor = 'black';

            if (this.state.isOver == true) {
                buttonColor = properties.BROWSER_HOVER_COLOR;
                textColor = '#2299D6';
            } else {
                buttonColor = properties.BROWSER_COLOR;
                textColor = '#000000';
            }
        }

        const tabStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth,
            height: properties.BROWSER_BUTTON_HEIGHT,
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            color: 'white',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            margin: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left',
            borderStyle: 'none',
            paddingRight: 0,
            paddingBottom: 0,
            paddingTop: 0
        };

        const spanStyle = {
            position: 'absolute',
            top: 5,
            color: textColor,
            fontSize: 15,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const iconStyle = {
            position: 'absolute',
            top: 6,
            right: properties.BROWSER_LEFT_PADDING + properties.BROWSER_ICON_RIGHT_PADDING,
            color: iconColor
        };

        const topLine = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: tabStyle.width,
            height: 1,
            background: 'white',
            display: 'block'
        };

        var idValue;

        if (this.props.index == 0)
            idValue = 'backgroundElement';

        return (
            <button id={idValue} aria-label={this.props.text} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={topLine}></span>
                <span style={spanStyle}>{this.props.text}</span>
                <i style={iconStyle} className={icon}></i>
            </button>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;
    var activeButton = state.accordion.activeButton;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (activeButton == undefined)
        activeButton = 0;

    return {
        accordionWidth,
        activeButton
    };
}

export const BrowserButton = connect(mapStateToProps)(BrowserButtonContent);



/** WEBPACK FOOTER **
 ** ./src/components/accordion/BrowserButton.js
 **/